"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatItemTitle = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../utils/classFunctions");
require("./index.scss");
const className = 'passengers-seat-on-flights-item-title';
class SeatItemTitle extends react_1.default.PureComponent {
    render() {
        const { flightDate, flightTime, flightNumber, airportsFromToByName, tariffName, modificators, } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        const leftPartLine1 = flightNumber;
        const leftPartLine2 = airportsFromToByName;
        const leftPartLine3 = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PassengersSeatsOnFlights/Item/Title/Label:flightDateAndTime', description: 'Label line with flight date ant departure time', defaultMessage: '{flightDate}, {flightTime}', values: {
                flightDate,
                flightTime,
            } }));
        const rightPartLine1 = tariffName;
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__left-part` },
                react_1.default.createElement("div", { className: `${className}__line` }, leftPartLine1),
                react_1.default.createElement("div", { className: `${className}__line` }, leftPartLine2),
                react_1.default.createElement("div", { className: `${className}__line` }, leftPartLine3)),
            react_1.default.createElement("div", { className: `${className}__right-part` },
                react_1.default.createElement("div", { className: `${className}__line` }, rightPartLine1))));
    }
}
exports.SeatItemTitle = SeatItemTitle;
//# sourceMappingURL=index.js.map